import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSeFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53887)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M49.1393 41.3797H0.863573C0.387499 41.3797 0.00146484 40.9937 0.00146484 40.5176V9.4832C0.00146484 9.00713 0.387499 8.62109 0.863573 8.62109H49.1394C49.6154 8.62109 50.0015 9.00713 50.0015 9.4832V40.5176C50.0014 40.9938 49.6153 41.3797 49.1393 41.3797Z",
				fill: "#4173CD"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M50.0014 22.4141H20.6911V8.62109H15.5187V22.4141H0.00146484V27.5866H15.5187V41.3796H20.6911V27.5866H50.0014V22.4141Z",
				fill: "#FFE15A"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53887",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSeFlag);
export { ForwardRef as ReactComponent };
